export const LOAD_COURSES_SPECIFIC_COURSE = 'LOAD_COURSES_SPECIFIC_COURSE';
export const LOAD_COURSES_SPECIFIC_COURSE_SUCCESS = 'LOAD_COURSES_SPECIFIC_COURSE_SUCCESS';
export const LOAD_COURSES_SPECIFIC_COURSE_FAIL = 'LOAD_COURSES_SPECIFIC_COURSE_FAIL';
